import React, { useState, useRef } from 'react';
import { footer } from "../data";
import appStore from '../assets/appStore.svg';
import googlePlay from '../assets/googlePlay.svg';
import '../styles/Footer.scss';
import { contact } from '../data';
import emailjs from '@emailjs/browser';
import '../styles/Contact.scss';
import Swal from 'sweetalert2';
import { useModal } from '../hooks/useModal'
import Modal from './Modal'

function Footer() {

    const [done, setDone] = useState(false);
    const [isOpenModal1, openModal1, closeModal1] = useModal(false);
    const [isOpenModal2, openModal2, closeModal2] = useModal(false);

    const [input, setInput] = useState({
        user_name: "",
        user_email: "",
        message: ""
    })

    const formRef = useRef();

    function handleSubmit(e) {
        e.preventDefault();

        emailjs.sendForm('service_snyv3nh', 'template_fazwzit', formRef.current, 'user_NgEKdQ7IHycvsekyXWADT')
            .then((result) => {
                console.log(result.text);
                setDone(true);
                setInput({
                    user_name: "",
                    user_email: "",
                    message: ""
                })
            }, (error) => {
                console.log(error.text);
            });
    }

    function handleChange(e) {
        setInput(e.target.value);
    }

    return (
        <>
            <footer>
                <ul>
                    <li onClick={openModal1}>
                        <p>{footer.CONTACT}</p>
                    </li>
                    <li onClick={openModal2}>{footer.TERMS}</li>
                    <li className='googlePlay'>
                        <a href='https://play.google.com/store/apps/details?id=com.abaxaba.yat' target="_blank" rel="noreferrer"><img src={googlePlay} alt='Google Play' /></a>
                    </li>
                    <li>
                        <img src={appStore} onClick={() => Swal.fire({ title: 'Cooming soon', confirmButtonColor: '#4b0909', background: '#f9d6af', color: '#4b0909' })} alt='App Store' className='appStore' />
                    </li>
                </ul>
            </footer>
            <Modal isOpen={isOpenModal1} closeModal={closeModal1}>
                <form ref={formRef} onSubmit={handleSubmit}>
                    <h2>Contact</h2>
                    <input type='text' placeholder={contact.NAME} name='user_name' value={input.user_name} required minLength='3' onChange={handleChange} />
                    <input type='email' placeholder={contact.EMAIL} name='user_email' value={input.user_email} required minLength='4' onChange={handleChange} />
                    <textarea type='text' name='message' placeholder={contact.MESSAGE} value={input.message} required minLength='15' onChange={handleChange} />
                    <button type='submit'>{contact.BUTTON}</button>
                    {done && <span>Sent message</span>}
                </form>
            </Modal>
            <Modal isOpen={isOpenModal2} closeModal={closeModal2}>
				<h1>Privacy Policy</h1>
				<h2>Yet Another Tuner</h2>
				<p>Last updated: January 20, 2023</p>
				<p>This application does not collect or store personal data.</p>
				<p>When you contact us via email, we'll use your contact information to respond to you. We won't sell or share this info with anyone else.</p>
				<p>If you installed this application from Google Play or buy the premium version, then Google Play does collect some personal data. Please see the privacy policy for Google Play Services here: <a href="https://policies.google.com/privacy" rel="external nofollow noopener noreferrer" target="_blank">https://policies.google.com/privacy</a></p> 
				<p>If you have any questions about this Privacy Policy, You can contact us by visiting this page on our website: <a href="https://abaxaba.com/yat" rel="external nofollow noopener noreferrer" target="_blank">https://abaxaba.com/yat</a></p>
            </Modal>
        </>
    )
}

export default Footer;